(function(){

    var $opt = {
        'menu_mobile': 1100,
    };

    function openFooterLink(){
        var self = this;
        this.init = function(obj) {
            if(!this.isMenuMobile()) return;
            var links = $(obj).find('ul');
            var svg = $(obj).find('svg');
            if($(links).hasClass('open')){
                $(links).addClass('mobile:hide');
                $(links).removeClass('open');
                $(svg).removeClass('rotate-90').addClass('rotate-m90');
            }else{
                $(links).removeClass('mobile:hide');
                $(svg).removeClass('rotate-m90').addClass('rotate-90');
                $(links).addClass('open');
            }

        }

        //check is mobile
        this.isMenuMobile = function(){
            return jQuery(window).outerWidth(true) <= $opt.menu_mobile;
        }
    }



    $('.footer-block').click(function(){
        new openFooterLink().init(this);
    });

})();